var waitFor = require("../utils/waitFor");

function getUrlVar(key) {
  var result = new RegExp(key + "=([^&]*)", "i").exec(window.location.search);
  return (result && unescape(result[1])) || "";
}

waitFor("body.single-series #create", function () {
  var capRenderer = require("./renderer");

  var state = {
      curStep: 0,
      curExclusions: {},
      selectedOptions: {},
      allSelectedOptions: [],
      seriesData: {},
      curWidth: 0,
      curModules: 0,

      // for lookup by ID
      stepsDict: {},
      categoriesDict: {},
      optionsDict: {},
      groupsDict: {},
      groupExclusionsDict: {},
      optionExclusionsDict: {},

      // for iteration
      steps: [],
      categories: [],
      options: [],
      groups: [],
      groupExclusions: [],
      optionExclusions: [],
    },
    $stepSelector = $("#step-selector"),
    $stepContainer = $("#step-container"),
    $tracepartsButton = $(".traceparts-cap-button");

  window.state = state; // for debugging

  var ADV_WIDTH_SETTINGS = {
    LSP: {
      FEMALE_OPTION_IDS: [542, 543],
      VARIABLE_OPTIONS: {
        // Body Style 3
        517: {
          MALE: 5.4,
          FEMALE: 10,
        },

        // Body Style 4
        519: {
          MALE: 8,
          FEMALE: 10,
          // RANGE_FEMALE: [4.6],
        },

        // Body Style 5
        518: {
          MALE: 10,
          FEMALE: 5.4,
        },
      },
    },
    SP: {
      FEMALE_OPTION_IDS: [1204, 1205],
      VARIABLE_OPTIONS: {
        // Body Style 3
        1171: {
          MALE: 8,
          FEMALE: 5.6,
        },

        // Body Style 4
        1172: {
          MALE: 9.52,
          FEMALE: 10,
        },

        // Body Style 5
        1173: {
          MALE: 10,
          FEMALE: 5.6,
        },
      },
    },
  };

  function getOptionSpecialConfig(option) {
    // is this not a special series?
    var specialSerieNames = Object.keys(ADV_WIDTH_SETTINGS);
    if (specialSerieNames.indexOf(state.series.name) === -1) {
      return false;
    }

    var seriesSettings = ADV_WIDTH_SETTINGS[state.series.name];

    // is this not a special option in this series?
    var curSeriesSpecialOptionIds = Object.keys(
      seriesSettings.VARIABLE_OPTIONS
    );

    if (curSeriesSpecialOptionIds.indexOf(option.id.toString()) === -1) {
      return false;
    }

    return seriesSettings.VARIABLE_OPTIONS[option.id];
  }

  function getOptionWidth(option, additionalStateOption) {
    // if (option.code === "3") debugger;

    if (!option.width) return 0;

    var optionConfig = getOptionSpecialConfig(option);
    if (optionConfig === false) {
      return option.width;
    }

    var tempSelectedState = [...state.allSelectedOptions];
    if (additionalStateOption) {
      tempSelectedState.push(additionalStateOption.id);
    }

    var isFemale = tempSelectedState.some(function (optionId) {
      return (
        ADV_WIDTH_SETTINGS[state.series.name].FEMALE_OPTION_IDS.indexOf(
          optionId
        ) !== -1
      );
    });

    return isFemale ? optionConfig.FEMALE : optionConfig.MALE;
  }

  /**
   * Calculate the width of the connector based on the currently selected options
   * @param {object} additionalOption - an option to add to the calculation
   * @returns {number} - the width of the connector
   */
  function calculateConnectorWidth(additionalOption) {
    var width = 0;

    state.allSelectedOptions.forEach(function (optionId) {
      var option = state.optionsDict[optionId];

      width += getOptionWidth(option, additionalOption);
    });

    if (additionalOption) {
      width += getOptionWidth(additionalOption, additionalOption);
    }

    // range
    var rangeAdder = 0;
    var allOptions = [...state.allSelectedOptions];
    if (additionalOption) {
      allOptions.push(additionalOption.id);
    }

    var isFemale = allOptions.some(function (optionId) {
      return (
        ADV_WIDTH_SETTINGS[state.series.name].FEMALE_OPTION_IDS.indexOf(
          optionId
        ) !== -1
      );
    });

    if (isFemale) {
      allOptions.forEach(function (optionId) {
        var optionConfig = getOptionSpecialConfig(state.optionsDict[optionId]);
        if (optionConfig === false || !optionConfig.RANGE_FEMALE) {
          return;
        }

        rangeAdder = Math.max(rangeAdder, optionConfig.RANGE_FEMALE);
      });

      if (rangeAdder > 0)
        width = width.toFixed(2) + "mm to " + (width + rangeAdder).toFixed(2);
    }

    return width;
  }

  function indexSeriesData(seriesData) {
    state.series = seriesData.series;

    // sort steps by order
    state.series.steps = state.series.steps.sort(function (a, b) {
      return a.order - b.order;
    });

    // CaP preview stuff
    state.series.preview = false;
    if (state.series.max_width && state.series.max_width > 0)
      state.series.preview = "build";
    else if (state.series.num_modules && state.series.num_modules > 0)
      state.series.preview = "fixed";

    // index the series things
    state.series.steps.forEach(function (step) {
      state.selectedOptions[step.id] = step.allow_multiple ? [] : 0;

      state.stepsDict[step.id] = step;
      state.steps.push(step);

      step.categories.forEach(function (category) {
        state.categoriesDict[category.id] = category;
        state.categories.push(category);

        category.options.forEach(function (option) {
          option.groups = [];
          option.stepId = step.id;

          // will hold excluded options and the exclusion rule associated
          option.exclusions = {};

          state.optionsDict[option.id] = option;
          state.options.push(option);
        });
      });
    });

    // index exclusion stuff
    state.groups = seriesData.groups;
    state.groups.forEach(function (group) {
      // will hold excluded groups and the exclusion rule associated
      group.exclusions = {};

      state.groupsDict[group.id] = group;

      group.options.forEach(function (optionId) {
        state.optionsDict[optionId].groups.push(group.id);
      });
    });

    state.groupExclusions = seriesData.groupExclusions;
    state.groupExclusions.forEach(function (groupExclusion) {
      state.groupExclusionsDict[groupExclusion.id] = groupExclusion;

      groupExclusion.groups.forEach(function (groupId, ind) {
        var otherGroupId =
          ind == 1 ? groupExclusion.groups[0] : groupExclusion.groups[1];
        state.groupsDict[groupId].exclusions[otherGroupId] = groupExclusion.id;
      });
    });

    state.optionExclusions = seriesData.optionExclusions;
    state.optionExclusions.forEach(function (optionExclusion) {
      state.optionExclusionsDict[optionExclusion.id] = optionExclusion;

      optionExclusion.options.forEach(function (optionId, ind) {
        var otherOptionId =
          ind == 1 ? optionExclusion.options[0] : optionExclusion.options[1];
        state.optionsDict[optionId].exclusions[otherOptionId] =
          optionExclusion.id;
      });
    });
  }

  function updateExcludedOptionAndGroupIds() {
    var activeGroupIds = [],
      // store excluded groupIds as key of arrays containing exclusion ids
      excludedGroups = {},
      // store excluded optionIds as keys of arrays containing exclusion ids
      excludedOptions = {};

    // reset some state values that we're gonna recalculate
    state.curWidth = 0;
    state.curModules = 0;
    state.allSelectedOptions = [];

    // loop through the currently selected options
    for (var stepId in state.selectedOptions) {
      var curOptionIds =
        typeof state.selectedOptions[stepId] == "number"
          ? [state.selectedOptions[stepId]]
          : state.selectedOptions[stepId];

      $.each(curOptionIds, function (curOptInd, curOptionId) {
        if (!curOptionId) return;

        state.allSelectedOptions.push(curOptionId);

        // populate excluded groups
        state.optionsDict[curOptionId].groups.forEach(function (groupId) {
          if (activeGroupIds.indexOf(groupId) > -1) return;

          activeGroupIds.push(groupId);

          for (var exGroupId in state.groupsDict[groupId].exclusions) {
            var exclusionId = state.groupsDict[groupId].exclusions[exGroupId];

            if (typeof excludedGroups[exGroupId] == "undefined")
              excludedGroups[exGroupId] = [];

            excludedGroups[exGroupId].push(exclusionId);
          }
        });

        // populate excluded options
        for (var exOptionId in state.optionsDict[curOptionId].exclusions) {
          var exclusionId =
            state.optionsDict[curOptionId].exclusions[exOptionId];

          if (typeof excludedOptions[exOptionId] == "undefined")
            excludedOptions[exOptionId] = [];

          excludedOptions[exOptionId].push(exclusionId);
        }

        // max width concerns
        if (state.series.preview == "build") {
          state.curWidth = calculateConnectorWidth();
        }

        // max module num concerns
        if (
          state.series.preview == "fixed" &&
          typeof state.optionsDict[curOptionId].build_image !== "undefined"
        ) {
          state.curModules++;
        }
      });
    }

    state.curExclusions = {
      groups: excludedGroups,
      options: excludedOptions,
    };
  }

  function getExclusionReason(exclusionType, ruleId, thisId) {
    var exclusionDict =
        exclusionType == "option"
          ? "optionExclusionsDict"
          : "groupExclusionsDict",
      rule = state[exclusionDict][ruleId],
      otherEntityLabel;

    if (typeof rule.explanation !== "undefined")
      return {
        type: "custom",
        value: rule.explanation,
      };

    if (exclusionType == "option") {
      var otherOptId =
          rule.options.indexOf(thisId) === 0
            ? rule.options[1]
            : rule.options[0],
        otherOpt = state.optionsDict[otherOptId],
        otherOptStep = state.stepsDict[otherOpt.stepId];

      otherEntityLabel = otherOpt.code + " (" + otherOptStep.name + ")";
    } else {
      var otherGroupId =
          rule.groups.indexOf(thisId) === 0 ? rule.groups[1] : rule.groups[0],
        otherGroup = state.groupsDict[otherGroupId];

      otherEntityLabel = otherGroup.name;
    }

    return {
      type: "auto",
      value: otherEntityLabel,
    };
  }

  function getCurrentPreviewImageData() {
    var images = [];

    // loop through selected options to get image srcs
    $.each(state.selectedOptions, function (stepId, optionIds) {
      var curOptionIds =
        typeof state.selectedOptions[stepId] == "number"
          ? [state.selectedOptions[stepId]]
          : state.selectedOptions[stepId];

      $.each(curOptionIds, function (i, optionId) {
        if (
          !optionId ||
          typeof state.optionsDict[optionId].build_image === "undefined" ||
          state.optionsDict[optionId].build_image.length === 0
        )
          return;

        images.push({
          src: state.optionsDict[optionId].build_image,
          flip: state.stepsDict[stepId].build_mirror,
        });
      });
    });

    // if we're missing images for selected part, hide it
    if (images.length == 0) return false;

    return images;
  }

  function updateConnectorPreview() {
    var images = [];

    if (!state.series.preview) return;

    switch (state.series.preview) {
      case "build":
        images = getCurrentPreviewImageData();

        capRenderer.drawPreviewModular({
          images: images,
          width: state.curWidth,
        });

        break;

      case "fixed":
        // loop through selected options to get image srcs
        $.each(state.selectedOptions, function (stepId, optionIds) {
          var curOptionIds =
            typeof state.selectedOptions[stepId] == "number"
              ? [state.selectedOptions[stepId]]
              : state.selectedOptions[stepId];

          $.each(curOptionIds, function (i, optionId) {
            if (
              !optionId ||
              typeof state.optionsDict[optionId].build_image === "undefined" ||
              state.optionsDict[optionId].build_image.length === 0
            )
              return;

            images.push(state.optionsDict[optionId].build_image);
          });
        });

        capRenderer.drawPreviewFixed({
          images: images,
          placeholder: state.series.module_placeholder,
          num_modules: state.series.num_modules,
          template: state.series.template_image,
        });

        break;
    }

    // update download form data, too
    $("#download-preview-images-data").val(JSON.stringify(images));
    $("#download-preview-partnumber").val(getCurrentPartNumber());
  }

  function applyExclusions(optionIds) {
    var excludedOptionIds = Object.keys(state.curExclusions.options),
      excludedGroupIds = Object.keys(state.curExclusions.groups);

    if (!optionIds) optionIds = Object.keys(state.optionsDict);

    optionIds.forEach(function (optionId) {
      var thisOption = state.optionsDict[optionId],
        isExcluded = false,
        allReasons = [],
        customReasons = [],
        autoReasons = [],
        tooltipContent = "",
        excludedIndex,
        newReason;

      // if it's selected on a non-multiple options step, move on
      if (
        state.allSelectedOptions.indexOf(parseInt(optionId)) > -1 &&
        !state.stepsDict[state.optionsDict[optionId].stepId].allow_multiple
      )
        return;

      if (thisOption.groups) {
        thisOption.groups.forEach(function (groupId) {
          excludedIndex = excludedGroupIds.indexOf(String(groupId));

          if (excludedIndex == -1) return; //continue

          // if this option is excluded from this rule, continue
          var optionIsExcepted = false;
          state.curExclusions.groups[groupId].forEach(function (ruleId) {
            if (
              $.inArray(
                thisOption.id,
                state.groupExclusionsDict[ruleId].except
              ) !== -1
            ) {
              optionIsExcepted = true;
            }
          });
          if (optionIsExcepted) return; //continue

          isExcluded = true;

          state.curExclusions.groups[groupId].forEach(function (ruleId) {
            newReason = getExclusionReason("group", ruleId, groupId);
            allReasons.push(newReason);
          });
        });
      }

      // we only need to concern ourselves with option exclusions
      // if there are no group exclusions applied by this point
      excludedIndex = excludedOptionIds.indexOf(optionId);
      if (!isExcluded && excludedIndex > -1) {
        isExcluded = true;
        state.curExclusions.options[optionId].forEach(function (ruleId) {
          newReason = getExclusionReason("option", ruleId, optionId);
          allReasons.push(newReason);
        });
      }

      // see if we should disable it because of width
      if (
        state.series.preview == "build" &&
        calculateConnectorWidth(thisOption) > state.series.max_width
      ) {
        isExcluded = true;
        newReason = {
          type: "custom",
          value: "Adding this component will exceed connector's maximum width.",
        };
        allReasons.push(newReason);
      }

      // see if we should disable it because of max number of modules
      if (
        state.series.preview == "fixed" &&
        typeof thisOption.build_image !== "undefined" &&
        state.curModules == state.series.num_modules
      ) {
        isExcluded = true;
        newReason = {
          type: "custom",
          value:
            "Adding this component will exceed connector's maximum allowed modules.",
        };
        allReasons.push(newReason);
      }

      // disable or un-disable it
      $("#option-radio-" + optionId).prop("disabled", isExcluded);

      // update reasons tooltip
      if (allReasons.length > 0) {
        customReasons = allReasons
          .filter(function (reason) {
            return reason.type == "custom";
          })
          .map(function (reason) {
            return reason.value;
          });

        autoReasons = allReasons
          .filter(function (reason) {
            return reason.type == "auto";
          })
          .map(function (reason) {
            return reason.value;
          });

        // make sure there are no duplicate autoReasons
        var uniqueVals = [];
        $.each(autoReasons, function (i, el) {
          if ($.inArray(el, uniqueVals) === -1) uniqueVals.push(el);
        });
        autoReasons = uniqueVals;

        tooltipContent += customReasons.join("<br/>");
        if (customReasons.length > 0) tooltipContent += "<br/><br/>";

        if (autoReasons.length > 0)
          tooltipContent += "The following items are incompatible:<br/>";
        tooltipContent += autoReasons.join("<br/>");

        $("#cap-option-" + optionId + " .picker-tooltip").html(tooltipContent);
      }
    });
  }

  function getOptionByCode(stepId, optionCode) {
    var theOption = false;

    optionCode = optionCode.toUpperCase();

    $.each(state.options, function (i, el) {
      if (el.stepId != stepId || el.code != optionCode) return;

      theOption = el;
      return false;
    });

    return theOption;
  }

  function getCurrentPartNumber() {
    var partNumber = state.series.name;

    $.each(state.steps, function (order, stepData) {
      var curOptionIds =
        typeof state.selectedOptions[stepData.id] == "number"
          ? [state.selectedOptions[stepData.id]]
          : state.selectedOptions[stepData.id];

      $.each(curOptionIds, function (curOptInd, curOptionId) {
        if (curOptionId === 0) return;

        if (stepData.leading_character && curOptInd === 0)
          partNumber += stepData.leading_character;

        partNumber += String(state.optionsDict[curOptionId].code);
      });
    });

    return partNumber;
  }
  window.gpn = getCurrentPartNumber;

  function changeStep(stepId) {
    var $button = $stepSelector.find("[data-step-id=" + stepId + "]"),
      $step = $("#step-" + stepId);

    if (state.curStep == stepId) return;

    // hide currently open step & deactivate button
    $(".cap-step-container.step-current").removeClass("step-current");
    $stepSelector.find(".step-current").removeClass("step-current");

    // open new step
    $step.addClass("step-current");

    // make button active
    $button.addClass("step-current");

    // HACK: if this is the Environmental step, select /AA by default
    if (state.stepsDict[stepId].name == "Environmental Compliance") {
      var envOptionId = state.stepsDict[stepId].categories["0"].options["0"].id;

      // if the option isn't picked, pick it!
      if ($.inArray(envOptionId, state.allSelectedOptions) == -1) {
        setStepOption(stepId, envOptionId);
        $("#option-radio-" + envOptionId).prop("checked", true);
      }
    }

    capRenderer.scrollToCapTop();

    state.curStep = stepId;
  }

  function maybeEnableNextActions() {
    var filledCount = 0;

    $.each(state.steps, function (ind, stepData) {
      if (
        !state.stepsDict[stepData.id].allow_multiple &&
        state.selectedOptions[stepData.id] != 0
      ) {
        filledCount++;
      } else if (
        state.stepsDict[stepData.id].allow_multiple &&
        state.selectedOptions[stepData.id].length > 0
      ) {
        filledCount += state.selectedOptions[stepData.id].length;
      }

      // we only need to check the first 3
      if (filledCount > 2) return false;
    });

    if (filledCount > 2) {
      $(".cap-requests").removeClass("not-ready");
      $(".cap-requests .button")
        .removeClass("button--disabled")
        .prop("disabled", false);
      $(".search-related-drawings")
        .removeClass("button--disabled")
        .prop("disabled", false);
      $(".get-generated-image")
        .removeClass("button--disabled")
        .prop("disabled", false);
    } else {
      $(".cap-requests").addClass("not-ready");
      $(".cap-requests .button")
        .addClass("button--disabled")
        .prop("disabled", true);
      $(".search-related-drawings")
        .addClass("button--disabled")
        .prop("disabled", true);
      $(".get-generated-image")
        .addClass("button--disabled")
        .prop("disabled", true);
    }
  }

  function clearStepSelection(stepId) {
    var $button = $stepSelector.find("[data-step-id=" + stepId + "]"),
      $stepWrap = $("#step-" + stepId);

    $stepWrap.find(".option-check:checked").prop("checked", false);
    $stepWrap.find(".clear-step-button").hide();
    $stepWrap.find(".next-step-button").hide();
    state.selectedOptions[stepId] = state.stepsDict[stepId].allow_multiple
      ? []
      : 0;
    $button.text("").removeClass("step-filled");

    updateExcludedOptionAndGroupIds();
    applyExclusions();
    maybeEnableNextActions();
    updateConnectorPreview();
  }

  function setStepOption(stepId, optionId) {
    var $stepWrap = $("#step-" + stepId),
      $button = $stepSelector.find("[data-step-id=" + stepId + "]"),
      newStepCode = "";

    // uncheck current checked item
    $stepWrap
      .find('.option-check:checked:not([value="' + optionId + '"])')
      .prop("checked", false);

    // set new option
    state.selectedOptions[stepId] = parseInt(optionId);

    $stepWrap.find(".clear-step-button").show();
    $stepWrap.find(".next-step-button").show();

    updateExcludedOptionAndGroupIds();
    applyExclusions();
    maybeEnableNextActions();
    updateConnectorPreview();
    updateTraceparts();

    if (state.stepsDict[stepId].leading_character)
      newStepCode += state.stepsDict[stepId].leading_character + " ";

    newStepCode += state.optionsDict[optionId].code;

    $button.text(newStepCode).addClass("step-filled");
  }

  function setStepMultipleOption(stepId, optionId) {
    var $stepWrap = $("#step-" + stepId),
      $button = $stepSelector.find("[data-step-id=" + stepId + "]"),
      newStepCode = "";

    state.selectedOptions[stepId].push(parseInt(optionId));

    $stepWrap.find(".clear-step-button").show();
    $stepWrap.find(".next-step-button").show();

    updateExcludedOptionAndGroupIds();
    applyExclusions();
    maybeEnableNextActions();
    updateConnectorPreview();
    updateTraceparts();

    $button.addClass("step-filled");

    // generate new code string
    if (state.stepsDict[stepId].leading_character)
      newStepCode += state.stepsDict[stepId].leading_character;

    $.each(state.selectedOptions[stepId], function (ind, optId) {
      newStepCode += state.optionsDict[optId].code;
    });

    $button.text(newStepCode);
  }

  function updateTraceparts() {
    var curNumber = getCurrentPartNumber();

    $tracepartsButton
      .removeClass("traceparts-preview")
      .removeClass("download-3d")
      .addClass("button--disabled")
      .prop("disabled", false);

    // check if we have an exact match w/ drawing
    $.get(
      window.SITE_SETTINGS.ajaxurl,
      { action: "posi_part_number_lookup", part_number: curNumber },
      function (data) {
        var matchClass = false;
        var drawingPartNumber;
        $.each(data.results, function (i, partResult) {
          if (partResult.matchHasTP || partResult.matchHasStep) return;
          if (partResult.hasStep || partResult.onTP) {
            matchClass = "download-3d";
            drawingPartNumber = partResult.partNumber;
          }
          if (partResult.onTP) matchClass = "traceparts-preview";
        });

        if (matchClass.length > 0) {
          $tracepartsButton
            .addClass(matchClass)
            .removeClass("button--disabled")
            .prop("disabled", false);

          window.partSearchKey = data.key;
          $tracepartsButton.attr("data-part", drawingPartNumber);
        }
      },
      "json"
    );
  }

  function gotoNextStep() {
    var nextStepOrder = state.stepsDict[state.curStep].order
        ? state.stepsDict[state.curStep].order + 1
        : 1,
      nextStep;

    $.each(state.steps, function (i, step) {
      if (step.order != nextStepOrder) return;

      nextStep = step;
      return false;
    });

    // if there's no next step, abort
    if (!nextStep) return;

    changeStep(nextStep.id);
  }

  function setInitialViewState() {
    // get number from URL param minus the series name
    var defaultNumber = getUrlVar("part-number").substring(
      window.SERIES.length
    );

    if (defaultNumber.length > 0) {
      // for now, we know that's just step 0
      var theOption = getOptionByCode(state.series.steps[0].id, defaultNumber);

      if (theOption !== false) {
        setStepOption(state.series.steps[0].id, theOption.id);

        // select the following step
        return changeStep(state.series.steps[1].id);
      } else {
        console.error("Could not find matching option for " + defaultNumber);
      }
    }

    // maybe setup preview
    if (state.series.preview == "build") {
      capRenderer.drawPreviewModular();
      $("#download-preview-cap-type-data").val("modular");
    } else if (state.series.preview == "fixed") {
      capRenderer.drawPreviewFixed({
        placeholder: state.series.module_placeholder,
        num_modules: state.series.num_modules,
        template: state.series.template_image,
      });

      $("#download-preview-placeholder-data").val(
        state.series.module_placeholder
      );
      $("#download-preview-num-modules-data").val(state.series.num_modules);
      $("#download-preview-background-data").val(state.series.template_image);
      $("#download-preview-cap-type-data").val("fixed");
    }

    // select the first step
    changeStep(state.series.steps[0].id);
  }

  // listeners
  // change step on selector click
  $stepSelector.on("click", "button", function (e) {
    var $button = $(e.currentTarget),
      stepId = $button.data("step-id");

    if ($button.hasClass("step-series")) stepId = state.series.steps[0].id;

    changeStep(stepId);

    e.preventDefault();
  });

  // update step's option when selected
  $stepContainer.on("change, click", ".option-check", function (e) {
    var $selectedOptionInput = $(e.currentTarget);

    // force it to remain checked
    $selectedOptionInput.prop("checked", true);

    if (state.stepsDict[state.curStep].allow_multiple) {
      setStepMultipleOption(state.curStep, $selectedOptionInput.val());
    } else {
      setStepOption(state.curStep, $selectedOptionInput.val());
      gotoNextStep();
    }
  });

  // clear step selection button
  $stepContainer.on("click", ".clear-step-button", function (e) {
    var $selectedOptionInput = $(e.currentTarget);

    clearStepSelection(state.curStep);
  });

  // next step  button
  $stepContainer.on("click", ".next-step-button", function (e) {
    var $selectedOptionInput = $(e.currentTarget);

    gotoNextStep();
  });

  // options display toggle
  var $toggleExpandedOpts = $(".cap-show-expanded-options");
  $toggleExpandedOpts.on("change", function (e) {
    var $container = $toggleExpandedOpts.parents(".cap-options");

    if ($toggleExpandedOpts[0].checked) {
      $container.addClass("is-checked");
      $stepContainer.addClass("display-expanded-options");
    } else {
      $container.removeClass("is-checked");
      $stepContainer.removeClass("display-expanded-options");
    }
  });

  $(".search-related-drawings").on("click", function (e) {
    if ($(".search-related-drawings").hasClass("button--disabled")) return;

    window.location =
      window.SITE_SETTINGS.blogurl +
      "/part-search?part-search=" +
      getCurrentPartNumber();
  });

  $(".cap-requests form").on("submit", function (e) {
    var redirUrl = window.SITE_SETTINGS.blogurl + "/contact/?request-details=",
      requestDetails = [];

    e.preventDefault();

    // abort if the part number isn't sufficiently built-out
    if ($(this).parent().hasClass("not-ready")) {
      return false;
    }

    // add request details
    if ($("#request-sample").is(":checked")) requestDetails.push("sample");

    if ($("#request-sample").is(":checked")) requestDetails.push("quote");

    redirUrl += requestDetails.join(",");

    redirUrl += "&request-part-number=" + encodeURI(getCurrentPartNumber());

    redirUrl += "#form-request";

    window.location = redirUrl;
  });

  function initCaP() {
    // load series data from PPM
    $.ajax({
      url: SITE_SETTINGS.apiUrl + "/series/" + window.SERIES + "/exclusions/",
      method: "GET",
      dataType: "json",
    }).always(function (seriesData) {
      if (!seriesData) {
        $(".loading-absolute").text(
          "Sorry, we could not load Create a Part series data. Please try again later or contact sales for assistance."
        );
        console.error("Could not load series data");
        return;
      }

      // process it
      indexSeriesData(seriesData);

      // render it!
      capRenderer.renderSeries(state.series.steps);

      // set initial state
      setInitialViewState();
    });
  }

  initCaP();
});
